import React, { useState, useEffect, useRef } from "react";
import { yupResolver } from "@hookform/resolvers";
import * as yup from "yup";
import { Form, Row } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { Button } from "../../components";
import _, { min, range } from "lodash";
import "../../css/bootstrap-datepicker.css";
import "react-datepicker/dist/react-datepicker.css";
import "./security-details.scss";
import "./formFile.scss";
import { useSelector } from "react-redux";
import {
  getAnnualIncomeDetails,
  getDeviceDetails,
  getOccupationDetails,
  getSourceOfFundDetails,
} from "./details.slice";
import { useDispatch } from "react-redux";
import { lowerCase } from "../../utils";
import { noNum } from "../Landing/utils";
const Options = [
  { option: "Yes", id: "Yes", value: "Y" },
  { option: "No", id: "No", value: "N" },
];
const OptionsForTwo = [
  { option: "Yes", id: "Yes", value: "Y" },
  { option: "No", id: "No", value: "N" },
];
const OptionsForThree = [
  { option: "Yes", id: "Yes", value: "Y" },
  { option: "No", id: "No", value: "N" },
];

const SecuirityDetails = ({
  onSubmitSecuirityHdfc,
  backupText,
  setBackupText,
  formDataSecuirityHdfc,
}) => {
  console.log("formDataSecuirityHdfc", formDataSecuirityHdfc);
  const validationSchema = () =>
    yup.object({
      ...(backupText.length == 0 && {
        SecurityIncidentReason: yup
          .string()
          .when("IsSecurityIncidentandLossHistory", {
            is: "Y",
            then: yup.string().required("This field is required"),
          }),
      }),

      Occupation: yup
        .string()
        .required("Please choose the correct value")
        .test(
          "Occupation",
          "Please choose the correct value",
          (val) => val !== "Select"
        ),
      AnnualIncome: yup
        .string()
        .required("Please choose the correct value")
        .test(
          "AnnualIncome",
          "Please choose the correct value",
          (val) => val !== "Select"
        ),
      SourceOfFund: yup
        .string()
        .required("Please choose the correct value")
        .test(
          "SourceOfFund",
          "Please choose the correct value",
          (val) => val !== "Select"
        ),
      RemarksForSourceOfFund: yup.string().when("SourceOfFund", {
        is: "Other",
        then: yup.string().required("This field is required"),
      }),

      Devicess: yup
        .string()
        .required("Please choose the correct value")
        .test(
          "Devicess",
          "Please choose the correct value",
          (val) => val !== "Select"
        ),
      DeviceRemarks: yup.string().when("Devicess", {
        is: "Other",
        then: yup.string().required("This field is required"),
      }),
    });

  const {
    handleSubmit,
    control,
    register,
    watch,
    reset,
    errors,
    setError,
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema()),
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: formDataSecuirityHdfc || {},
  });
  console.log("againError", errors);

  const securityQ1Ref = useRef();
  const attachRef = (ref) => {
    register(ref);
    securityQ1Ref.current = ref;
  };
  const securityQ2Ref = useRef();
  const attachRefQ2 = (ref) => {
    register(ref);
    securityQ2Ref.current = ref;
  };
  const securityQ3Ref = useRef();
  const attachRefQ3 = (ref) => {
    register(ref);
    securityQ3Ref.current = ref;
  };
  const securityQ1 = watch("IsSecurityIncidentandLossHistory");
  const securityQ2 = watch("IsAntiVirusInstalledInDevices");
  const securityQ3 = watch("IsDevicePasswordChangeRegularly");
  const SourceOfFund = watch("SourceOfFund");
  const Devicess = watch("Devicess");
  // API CALL FOR VALUES
  const dispatch = useDispatch();
  const [occupationData, setOccupationData] = useState("OCCUPATION");
  const [incomeData, setIncomeData] = useState("ANNUAL_INCOME");
  const [fundData, setFundData] = useState("SOURCE_OF_FUND");
  const [devicesData, setdevicesData] = useState("DEVICES");
  const [secuirityIncidentError, setSecuirityIncidentError] = useState(false);
  const { data } = useSelector(
    (state) => state.detailsform?.occupation_responce
  );
  const data2 = [{ Key: "3", Data: "Select" }];
  const newData = data?.data?.concat(data2);

  const annualIncome = useSelector(
    (state) => state.detailsform?.annualincome_responce?.data
  );
  const data3 = [{ Id: "6", Value: "Select" }];
  const annualIncomedata = annualIncome?.data?.concat(data3);

  const sourceOfFund = useSelector(
    (state) => state.detailsform?.sourcefund_responce?.data
  );
  const data4 = [{ Key: "4", Data: "Select" }];
  const sourceOfFundData = sourceOfFund?.data.concat(data4);

  const deviceData = useSelector(
    (state) => state.detailsform?.devices_responce?.data
  );
  const data5 = [{ Key: "6", Data: "Select" }];
  const newDeviceData = deviceData?.data.concat(data5);
  console.log("sourceOfFund ", SourceOfFund);
  useEffect(() => {
    if (occupationData === "OCCUPATION") {
      let data = { masterKey: occupationData };
      dispatch(getOccupationDetails(data));
    }
  }, [occupationData, dispatch]);
  useEffect(() => {
    if (incomeData === "ANNUAL_INCOME") {
      let data = { masterKey: incomeData };
      dispatch(getAnnualIncomeDetails(data));
    }
  }, [incomeData, dispatch]);
  useEffect(() => {
    if (fundData === "SOURCE_OF_FUND") {
      let data = { masterKey: fundData };
      dispatch(getSourceOfFundDetails(data));
    }
  }, [fundData, dispatch]);
  useEffect(() => {
    if (devicesData === "DEVICES") {
      let data = { masterKey: devicesData };
      dispatch(getDeviceDetails(data));
    }
  }, [devicesData, dispatch]);
  return (
    <Form
      noValidate
      className="personal-details-form"
      onSubmit={handleSubmit(onSubmitSecuirityHdfc)}
    >
      <div className="form-group p-2">
        <label style={{ fontSize: "14px" }}>
          Security Incident and Loss history :- Are you or your family members
          aware of any incident which may lead to any loss or claim under any of
          the section of the policy you are applying for?
        </label>

        <div>
          {Options.map((item) => (
            <div class="custom-control custom-radio">
              <input
                type="radio"
                className="custom-control-input1"
                id={item?.option}
                name="IsSecurityIncidentandLossHistory"
                value={item?.value}
                ref={attachRef}
                defaultChecked
              />
              <label className="custom-control-label1" for={item?.id}>
                {item?.option || "-"}
              </label>
            </div>
          ))}
        </div>
        <br />
        {securityQ1 === "Y" && (
          <>
            <Form.Control
              as="textarea"
              rows="2"
              cols="50"
              name="SecurityIncidentReason"
              className="backupTextArea"
              value={backupText}
              onChange={(evt) => setBackupText(evt.target.value)}
            />
            {errors?.SecurityIncidentReason ? (
              <p className="error">{errors?.SecurityIncidentReason?.message}</p>
            ) : (
              ""
            )}
          </>
        )}
      </div>

      <b style={{ marginTop: "7px", marginBottom: "10px", fontSize: "20px" }}>
        Other Questions
      </b>
      <div className="form-group p-2">
        <label style={{ fontSize: "14px" }}>
          Is anti-virus software installed in your devices?
        </label>

        <div>
          {OptionsForTwo.map((item) => (
            <div class="custom-control custom-radio">
              <input
                type="radio"
                className="custom-control-input2"
                id={item?.option}
                name="IsAntiVirusInstalledInDevices"
                value={item?.value}
                ref={attachRefQ2}
                defaultChecked
              />
              <label className="custom-control-label2" for={item?.id}>
                {item?.option || "-"}
              </label>
            </div>
          ))}
        </div>
      </div>
      <div className="form-group p-2">
        <label style={{ fontSize: "14px" }}>
          Do you change password of your device regularly?
        </label>

        <div>
          {OptionsForThree.map((item) => (
            <div class="custom-control custom-radio">
              <input
                type="radio"
                className="custom-control-input3"
                id={item?.option}
                name="IsDevicePasswordChangeRegularly"
                value={item?.value}
                ref={attachRefQ3}
                defaultChecked
              />
              <label className="custom-control-label3" for={item?.id}>
                {item?.option || "-"}
              </label>
            </div>
          ))}
        </div>
      </div>
      <Row xs={1} sm={1} md={1} lg={3} xl={3}>
        <div className="p-2">
          <Form.Group
            controlId="exampleForm.SelectCustom"
            className="select-custom"
          >
            <Form.Label style={{ fontSize: "14px" }}>Occupation</Form.Label>
            <Controller
              as={
                <Form.Control
                  as="select"
                  value={formDataSecuirityHdfc?.Occupation}
                >
                  <option selected="true" disabled hidden>
                    Select
                  </option>
                  {data?.data?.map((val) => {
                    return <option value={val?.Data}>{val?.Data}</option>;
                  })}
                </Form.Control>
              }
              required
              name="Occupation"
              control={control}
            />
          </Form.Group>
          {errors?.Occupation ? (
            <p className="error">{errors?.Occupation?.message}</p>
          ) : (
            ""
          )}
        </div>
        <div className="p-2">
          <Form.Group
            controlId="exampleForm.SelectCustom"
            className="select-custom"
          >
            <Form.Label style={{ fontSize: "14px" }}>Annual Income</Form.Label>
            <Controller
              as={
                <Form.Control as="select">
                  <option selected="true" disabled hidden>
                    Select
                  </option>
                  {annualIncome?.data?.map((val) => {
                    return <option value={val.Value}>{val.Value}</option>;
                  })}
                </Form.Control>
              }
              required
              name="AnnualIncome"
              control={control}
            />
            {errors?.AnnualIncome ? (
              <p className="error">{errors?.AnnualIncome?.message}</p>
            ) : (
              ""
            )}
          </Form.Group>
        </div>
        <div className="p-2">
          <Form.Group
            controlId="exampleForm.SelectCustom"
            className="select-custom"
          >
            <Form.Label style={{ fontSize: "14px" }}>Source Of Fund</Form.Label>
            <Controller
              as={
                <Form.Control as="select">
                  <option selected="true" disabled hidden>
                    Select
                  </option>
                  {sourceOfFund?.data?.map((val) => {
                    return <option value={val.Data}>{val.Data}</option>;
                  })}
                </Form.Control>
              }
              required
              name="SourceOfFund"
              control={control}
            />
            {errors?.SourceOfFund ? (
              <p className="error">{errors?.SourceOfFund?.message}</p>
            ) : (
              ""
            )}
          </Form.Group>
        </div>
        {SourceOfFund == "Other" && (
          <div className="p-2">
            <Form.Group>
              <Form.Label style={{ fontSize: "14px" }}>
                Remark for source of fund
              </Form.Label>
              <Controller
                as={<Form.Control className="text-capitalize" type="input" />}
                required
                onInput={(e) => {
                  lowerCase(e);
                  noNum(e);
                }}
                name="RemarksForSourceOfFund"
                control={control}
              />
              {errors?.RemarksForSourceOfFund ? (
                <p className="error">
                  {errors?.RemarksForSourceOfFund?.message}
                </p>
              ) : (
                ""
              )}
            </Form.Group>
          </div>
        )}
        <div className="p-2">
          <Form.Group
            controlId="exampleForm.SelectCustom"
            className="select-custom"
          >
            <Form.Label style={{ fontSize: "14px" }}>Devices</Form.Label>
            <Controller
              as={
                <Form.Control as="select">
                  <option selected="true" disabled hidden>
                    Select
                  </option>
                  {deviceData?.data?.map((val) => {
                    return <option value={val.Data}>{val.Data}</option>;
                  })}
                </Form.Control>
              }
              required
              name="Devicess"
              control={control}
            />
            {errors?.Devicess ? (
              <p className="error">{errors?.Devicess?.message}</p>
            ) : (
              ""
            )}
          </Form.Group>
        </div>
        {Devicess == "Other" && (
          <div className="p-2">
            <Form.Group>
              <Form.Label style={{ fontSize: "14px" }}>
                Remark for source of fund
              </Form.Label>
              <Controller
                as={<Form.Control className="text-capitalize" type="input" />}
                required
                onInput={(e) => {
                  lowerCase(e);
                  noNum(e);
                }}
                name="DeviceRemarks"
                control={control}
              />
              {errors?.DeviceRemarks ? (
                <p className="error">{errors?.DeviceRemarks?.message}</p>
              ) : (
                ""
              )}
            </Form.Group>
          </div>
        )}
      </Row>
      <Row style={{ justifyContent: "center", marginTop: "10px" }}>
        <Button
          style={{
            fontWeight: "400",
            fontSize: "15px",
            borderRadius: "0.25rem",
            height: "35px",
            paddingTop: "5px",
          }}
        >
          Submit Proposal Page
        </Button>
      </Row>
    </Form>
  );
};

export default SecuirityDetails;
